<script setup lang="ts">
defineProps<{ items: Array<{ id: string; name: string }> }>();
</script>

<template>
  {{ $t("dependency.stickies") }}
  <div v-for="item in items" :key="item.id" class="shortcut">
    {{ $t(item.name) }}
  </div>
</template>
